import { ru } from './ru';
import { en } from './en';

export type Language = 'ru' | 'en';
export type TranslationKey = keyof typeof ru;

export const translations = {
  ru,
  en,
};

export const defaultLanguage: Language = 'ru';

// Helper function to get nested translation value
export const getNestedValue = (obj: any, path: string): string | undefined => {
  const keys = path.split('.');
  let current: unknown = obj;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in (current as Record<string, unknown>)) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return undefined;
    }
  }

  return typeof current === 'string' ? current : undefined;
};

// Translation function with interpolation support
export const translate = (
  translations: typeof ru | typeof en,
  key: string,
  params?: Record<string, string | number>
): string => {
  const value = getNestedValue(translations, key);

  if (value === undefined) {
    return '';
  }

  let result = value;

  // Simple interpolation for {{param}} patterns
  if (params) {
    Object.entries(params).forEach(([paramKey, paramValue]) => {
      result = result.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(paramValue));
    });
  }

  return result;
};
